module.exports = __webpack_public_path__ + "img/arrow-left.575257be.svg";